import { reduxKey } from './constants';

export interface InitialDataType {
  isWatching: boolean;
}

export enum RequestError {
  UserNotFound = 0,
  FriendLimitReached = 1,
  GeneralError = 2,
}

export interface WatchButtonUserState {
  isLoading?: boolean;
  isWatching: boolean;
}

export interface WatchButtonState {
  [username: string]: WatchButtonUserState;
}

export interface WatchButtonStoreSlice {
  [reduxKey]?: WatchButtonState;
}
